

var getCurrentBlock = function getCurrentBlock(editorState) {
  var selection = editorState.getSelection();
  return editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
};

export default getCurrentBlock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-modifiers/es/utils/getCurrentBlock.js
// module id = 85
// module chunks = 0